var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpellCheckDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_1294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9121 18C13.7147 18 14.2497 17.2038 13.9589 16.4769L9.01571 4.00385C8.77146 3.39231 8.18991 3 7.53857 3C6.88723 3 6.30567 3.39231 6.06142 4.00385L1.11822 16.4769C0.82744 17.2038 1.3741 18 2.16501 18C2.63026 18 3.04897 17.7115 3.22344 17.2731L4.24697 14.5385H10.8069L11.8537 17.2846C12.0282 17.7115 12.4469 18 12.9121 18ZM5.13094 12.2308L7.53857 5.86154L9.9462 12.2308H5.13094Z",
    fill: "#ADADAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0391 17.3346C17.0391 18.068 17.6391 18.668 18.3724 18.668C19.1057 18.668 19.7057 18.068 19.7057 17.3346C19.7057 16.6013 19.1057 16.0013 18.3724 16.0013C17.6391 16.0013 17.0391 16.6013 17.0391 17.3346ZM17.0391 9.33464C17.0391 10.068 17.6391 10.668 18.3724 10.668C19.1057 10.668 19.7057 10.068 19.7057 9.33464C19.7057 8.6013 19.1057 8.0013 18.3724 8.0013C17.6391 8.0013 17.0391 8.6013 17.0391 9.33464ZM17.0391 13.3346C17.0391 14.068 17.6391 14.668 18.3724 14.668C19.1057 14.668 19.7057 14.068 19.7057 13.3346C19.7057 12.6013 19.1057 12.0013 18.3724 12.0013C17.6391 12.0013 17.0391 12.6013 17.0391 13.3346Z",
    fill: "#ADADAD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_1294"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpellCheckDark);
export default __webpack_public_path__ + "static/media/SpellCheckDark.c51b74adf41d7a0a9ecb7cd5e5b169f3.svg";
export { ForwardRef as ReactComponent };